import { WorkoutQueries } from './queries';
import { WorkoutMutations } from './mutations';

export const Workout = {
  queries: WorkoutQueries,
  mutations: WorkoutMutations,
};

export * from './types';
